export default {
// apiUrl: 'http://localhost:9090/redseat/',
s3Url: 'https://redseat-pdf.s3.amazonaws.com/',
apiUrl: 'https://api.courierdepotja.com/',
company: 10,
};
